<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {
        video: false,
        demo: 1,

        buttons: [
          {color: 'blue', title: "I'm Buying", active: false},
          {color: 'indigo', title: "Selling and Buying", active: false},
          {color: 'yellow', title: "Black Road", active: false},
          {color: 'purple', title: "Not Sure", active: false},
          {color: 'pink', title: "The Brown", active: false},
          {color: 'red', title: "Dog Ran", active: false},
          {color: 'orange', title: "Across The", active: false},
          {color: 'green', title: "To Catch The", active: false},
          {color: 'teal', title: "I'm Selling", active: false},
          {color: 'cyan', title: "I'm Buying", active: false},
          {color: 'warning', title: "Not Sure", active: false},
          {color: 'success', title: "The Brown", active: false},
          {color: 'info', title: "Dog Ran", active: false},
          {color: 'danger', title: "Across The", active: false},
          {color: 'dark', title: "I'm Selling", active: false},
        ],

        agents: [
          {
            name: 'Clark Rowley',
            email: 'clark.rowley@revinre.com',
            phone: '6029998090',
            titles: 'Administrative Assistant, Licensed Real Estate Salesperson',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: 'SA047458000',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669827/669827_04222022233648.jpg',
            url: 'https://clarkrowley.huntrealestateaz.com',
          },
          {
            name: 'Madeleine Laird',
            email: 'madeleine.laird@revinre.com',
            phone: '4803696366',
            titles: 'BDM, Licensed Real Estate Salesperson',
            about: `Madeleine Laird has spent the majority of her life in Arizona and considers herself an "almost native" to the valley. Madeleine has been licenced since 2018 and started her career in Real Estate flipping homes in the North Valley. In her current role, Madeleine is responsible for recruiting, training and retention for HUNT Real Estate's Arizona Region. Previous to joining HUNT Real Estate ERA, Madeleine worked in animal welfare, recruiting and sports marketing. `,
            real_estate_number: '',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669873/669873_02232022205751.png',
            url: 'https://madeleinelaird.huntrealestateaz.com',
          },
          {
            name: 'Robert Shaw',
            email: 'robert.shaw@revinre.com',
            phone: '4805700750',
            titles: 'Designated Broker',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: 'BR580019000',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669893/669893_03212022200237.jpg',
            url: 'https://robertshaw.huntrealestateaz.com',
          },
          {
            name: 'Paige Baker',
            email: 'paige.baker@revinre.com',
            phone: '4803385419',
            titles: 'HUNT Mortgage Consultant',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: 'NMLS #1005344',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/6505589/6505589_03042024141647.jpg',
            url: 'https://www.huntrealestateaz.com/bio/paigebaker',
          },
          {
            name: 'Alma Ramirez',
            email: 'alma.ramirez@revinre.com',
            phone: '3157265777',
            titles: 'Licensed Real Estate Salesperson',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: '',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669815/669815_03212022195030.jpg',
            url: 'https://www.huntrealestateaz.com/bio/almaramirez',
          },
          {
            name: 'Ashley Howell',
            email: 'ashley.howell@revinre.com',
            phone: '9072524310',
            titles: 'Licensed Real Estate Salesperson',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: '',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669818/669818_03212022195110.jpg',
            url: 'https://www.huntrealestateaz.com/bio/ashleyhowell',
          },
          {
            name: 'Buffy Tiller',
            email: 'buffy.tiller@revinre.com',
            phone: '4807294211',
            titles: 'Licensed Real Estate Salesperson',
            about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            real_estate_number: '',
            headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669822/669822_03212022195157.jpg',
            url: 'https://www.huntrealestateaz.com/bio/buffytiller',
          },
        ],
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="1"
    ></w-site-navbar>
    <main>

      <section class="">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://revinre.coryallen.app/storage/fm/revinre-nc/backgrounds/35.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-13 pb-12 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-7">
              <div class="text-center mb-4">
                <h1 class="mb-3 text-white" data-aos="fade-zoom-in">Office Agents</h1>
                <p class="text-white"  data-aos="fade-zoom-in">A list of agents associated with this office locations</p>
              </div>
            </div>
          </div>
        </div>
        <div class="position-absolute _pos-l-0 _pos-b-0 _pos-r-0 text-center">
          <ul class="list-inline">
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Facebook"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Twitter"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Instagram"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on YouTube"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
          </ul>
        </div>
      </section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:map-pin-user-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">Office Agents</h2>
            <p class="text-pre-wrap">Below you will find a list agents associated with the selected office location.</p>
          </div>
          <div class="row">
            <div v-for="(agent, agent_i) in agents" :key="agent_i" class="col-sm-3 mb-4">
              <div class="card overflow-hidden h-100">
                <div class="position-relative _p-t-100p">
                  <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _bg-repeat-none _bg-size-cover _bg-position-0-0" :style="'background-image: url('+formatImage(agent.headshot)+');'"></div>
                </div>
                <!-- <img class="card-img-top" :src="agent.headshot" alt="Card image cap"> -->
                <div class="card-body px-4 pt-4 pb-6">
                  <h3 class="card-title">{{ agent.name }}</h3>
                  <p class="text-muted small">{{ agent.titles }}</p>
                  <p class="text-muted small mb-2">{{ agent.real_estate_number }}</p>
                  <!-- <p class="card-text">{{ agent.about }}</p> -->
                  <div class="row mx-0 mb-2">
                    <div class="_w-15"><Icon icon="ri:mail-open-line" height="20" class="text-black" /></div>
                    <div class="col">{{ agent.email }}</div>
                  </div>
                  <div class="row mx-0">
                    <div class="_w-15"><Icon icon="ri:phone-line" height="20" class="text-black" /></div>
                    <div class="col">{{ formatPhone(agent.phone) }}</div>
                  </div>
                  <a :href="agent.url" target="_blank" class="btn btn-revinre position-absolute m-4 _pos-b-0 _pos-l-0 _pos-r-0"><Icon icon="ri:external-link-line" /> View Agent Page</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="bg-dark py-5"></section>

      

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>

<style>
.temp_hover_icon:hover .iconify, .temp_hover_icon:hover h6, .temp_hover_icon.on .iconify, .temp_hover_icon.on h6 {
  color: white !important;
}
</style>